import { API } from "../../../utils/api";

export const getPromosAndNotificationsApi = async (params) => {
  const response = await API.get("/promos-notifications", { params });
  return response.data;
};

export const getPromosAndNotificationsCountApi = async () => {
  const response = await API.get("/promos-notifications/total_counts");
  return response.data;
};

export const getPromosOrNotificationsDetailsApi = async (id) => {
  const response = await API.get(`promos-notifications/${id}`);
  return response.data;
};

export const createPromosOrNotificationsApi = async (data) => {
  const response = await API.post("promos-notifications", data);
  return response.data;
};

export const updatePromosOrNotificationsApi = async (id, data) => {
  const response = await API.post(`promos-notifications/${id}`, data);
  return response.data;
};

export const deletePromosOrNotificationsApi = async (id) => {
  const response = await API.delete(`promos-notifications/${id}`);
  return response.data;
};

export const clonePromosOrNotificationsApi = async (id) => {
  const response = await API.post(`promos-notifications/${id}/clone`);
  return response.data;
};

export const publishOrUnpublishPromosOrNotificationsApi = async ({
  id,
  type, //unpublished || published
}) => {
  const response = await API.patch(`promos-notifications/${id}/${type}`);
  return response.data;
};
